<template>
    <basic-content-layout>
        <div class="row container mt-5 h-100 margin-center">
            <div v-if="this.$root.whitelabel.setting('leads_endpage_content')" v-html="this.$root.whitelabel.setting('leads_endpage_content')"></div>

            <div v-else>
                <h4>{{ $t('route.finish-leads.text-fallback') }}</h4>
            </div>

            <div class="row container mt-1 margin-center" style="height: 50px;">
                <b-button @click="$goTo('catalog')">
                    {{$t('co.main.redirect')}}
                </b-button>
            </div>
        </div>
    </basic-content-layout>
</template>

<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import { BButton } from 'bootstrap-vue'

export default {
    name: 'FinishCheckoutPageLeads',
    
    components: {
        BasicContentLayout, BButton
    }
}
</script>

<style scoped>
.return-button {
    cursor: pointer;
}
.margin-center {
    margin: 0 auto;
}
</style>